// extracted by mini-css-extract-plugin
export default {"menuIconContainer":"br_f5","menuIcon":"br_f6","active":"br_bL"};